export default __webpack_public_path__ + "static/media/globe.861b2600.jpg";